import { onMounted } from 'vue';

export const useAppReady = () => {
  onMounted(() => {
    document.querySelector('html').classList.add('app--ready');
  });
};
